import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnChanges, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, catchError, combineLatest, of, ReplaySubject, Subject } from 'rxjs';
import { PagedResources } from 'src/app/interfaces/paged-resources';
import { BusinessuserService } from 'src/app/services/businessuser.service';
import { HouseholdService } from 'src/app/services/household.service';
import { McpService } from 'src/app/services/mcp.service';
import { ServiceService } from 'src/app/services/service.service';
import { TicketService } from 'src/app/services/ticket.service';

@Component({
  selector: 'app-tasks',
  templateUrl: './tasks.component.html',
  styleUrls: ['./tasks.component.scss']
})
export class TasksComponent implements OnInit, OnChanges {
  /**
   * pendingCustomers as ReplaySubject
   */
  pendingCustomers$: Subject<number> = new ReplaySubject(1);
  /**
   * waitingForDeactivation as ReplaySubject
   */
  waitingForDeactivation$: Subject<number> = new ReplaySubject(1);
  /**
   * partialMatch as ReplaySubject
   */
  partialMatch$: Subject<number> = new ReplaySubject(1);
  /**
   * householeBiggerThanThree as ReplaySubject
   */
  householeBiggerThanThree$: Subject<number> = new ReplaySubject(1);
  /**
   * nonEligibleUsers as ReplaySubject
   */
  nonEligibleUsers$: Subject<number> = new ReplaySubject(1);
  /**
   * newCard as BehaviorSubject
   */
  newCard$: BehaviorSubject<number> = new BehaviorSubject(null);
  /**
   * firstCards as BehaviorSubject
   */
  firstCards$: BehaviorSubject<number> = new BehaviorSubject(null);
  /**
   * form as BehaviorSubject
   */
  form$: BehaviorSubject<number> = new BehaviorSubject(null);

  showNonEligibleUsersCount: boolean = true;
  showPendingCustomersCount: boolean = true;



  /**
   * Count of  non eligible Users
   */
  nonEligibleUsersCount: number = 0;
  /**
   * Count of Users that are in State   pending
   */
  pendingCustomersCount: number = 0;
  /**
   * Count of Users that are waiting for Deactivation
   */
  waitingForDeactivationCount: number = 0;
  /**
   * Count of Users that need a first Card
   */
  firstCardsCount: number = 0;
  /**
   * Count of Users that need a new Card 
   */
  newCardCount: number = 0;
  /**
   * The Count of Users that have a partialMatch
   */
  partialMatchCount: number = 0;
  /**
   * The Count of all open Tickets
   */
  formCount: number = 0;
  /**
   * The Count of all Households
   */
  householdCount: number = 0;
  /**
   * The Config of the current Mandant
   */
  config: any;
  /**
   * Has all Data been loaded
   */
  finishedLoading: boolean = false;
  /**
   * has an Error occured while loading
   */
  errorWhileLoadingHousehold: boolean = false;
  /**
   * Freigabe / Berechtigung / Deaktivierung
   */
  hasExternalAuthentication: boolean = false;
  /**
   * fehlende Portalberechtigung 
   */
  hasCaseworkerCustomerSupplyContracts: boolean = false;
  /**
   * Kundenkaten
   */
  hasCardProductionView: boolean = false;

  usesSSO: boolean = false;
  /**
   * constructor
   * And set hasExternalAuthentication
   * @param businessuserService 
   * @param router 
   * @param ticketService 
   * @param householdService 
   * @param serviceService 
   * @param mcp 
   */
  constructor(
    private businessuserService: BusinessuserService,
    private router: Router,
    private ticketService: TicketService,
    private householdService: HouseholdService,
    private serviceService: ServiceService,
    private mcp: McpService) {
    this.serviceService.searchServices("external/authentication", null, null).subscribe((val: PagedResources<any>) => {
      if (val.content.length == 0) {
        this.hasExternalAuthentication = true;
      } else {
        this.hasExternalAuthentication = false;
      }
    })
  }
  /**
   * Load all Counts
   */
  ngOnInit(): void {
    combineLatest([
      this.mcp.loadConfiguration(),
      this.businessuserService.pendingCustomers$,
      this.businessuserService.waitingForDeactivation$,
      this.businessuserService.partialMatch$,
      this.businessuserService.nonEligibleUsers$,
      this.businessuserService.newCards$,
      this.businessuserService.firstCards$,
      this.ticketService.formCount$,
      this.householdService.getHouseHoldsWithAdultMembersCount(6).pipe(
        catchError(err => of(err))
      )
    ]).subscribe(([config, pendingCustomers, waitingForDeactivation, partialMatch, nonEligibleUsers, newCards, firstCards, formCount, householdCount]) => {
      if (householdCount instanceof HttpErrorResponse) {
        this.errorWhileLoadingHousehold = true;
      } else {
        this.householdCount = Number(householdCount);
      }
      this.config = config;
      this.usesSSO = config.usesSSO;


      this.showNonEligibleUsersCount = config.showNonEligibleUsersCount;
      this.showPendingCustomersCount = config.showPendingCustomersCount;

      if (config.hasCardProductionView) {
        this.hasCardProductionView = true;
      }
      this.pendingCustomersCount = pendingCustomers;
      this.waitingForDeactivationCount = waitingForDeactivation;
      this.partialMatchCount = partialMatch;
      this.nonEligibleUsersCount = nonEligibleUsers;
      this.newCardCount = newCards;
      this.firstCardsCount = firstCards;
      this.formCount = formCount;
      this.finishedLoading = true;
    })
  }


  ngOnChanges() {

  }

  /**
   * Move to the TicketPage with Filter
   * @param type 
   */
  moveToTicketPageWithFilter(type) {
    this.router.navigate(['caseworker/ticket'], { queryParams: { filterByTicketStates: 'NEW' } });
  }

  /**
   * Move to the Matching Page of the Filter
   * @param type 
   */
  moveToDashBoardPageWithFilter(type) {
    switch (type) {
      case "PENDING":
        this.router.navigate(['caseworker/dashboard'], { queryParams: { filterByState: 'PENDING', filterByCustomerType: 'MAINCUSTOMER,SUBCUSTOMER' } });
        break;
      case "DISABLE_REQUEST":
        this.router.navigate(['caseworker/dashboard'], { queryParams: { filterByState: 'DISABLE_REQUEST' } });
        break;
      case "hasNoValidELV":
        this.router.navigate(['caseworker/dashboard'], { queryParams: { filterByState: 'ACTIVE', filterByCustomerType: 'MAINCUSTOMER', hasNoValidELV: true } });
        break;
      case "partialMatchCount":
        this.router.navigate(['caseworker/dashboard'], { queryParams: { erpState: 'PARTIAL_MATCH' } });
        break;
      case "hasNoCard":
        this.router.navigate(['caseworker/dashboard'], { queryParams: { filterByState: 'ACTIVE', hasNoCard: true } });
        break;
      case "newCard":
        this.router.navigate(['caseworker/dashboard'], { queryParams: { filterByCustomerType: 'MAINCUSTOMER,SUBCUSTOMER', filterByState: "ACTIVE", filterByCardState: "CLOSE_REQUEST" } });
        break;
      case "household":
        this.router.navigate(['caseworker/household'], { queryParams: { count: 6 } });
        break;
    }
  }

  reloadPage() {
    window.location.reload();
  }

}
